export default function PaymentsTable({
  patients,
  packages,
   filterStatus,
  showBranchColumn,
  handleVPJCClick,
  formatStatus,
  statusColor,
  formatDate,
  hasSearched,
  loading,
}) {
 const showPatients =
  filterStatus.length === 0 ||
  filterStatus.includes("consultation") ||
  filterStatus.includes("treatment") ||
  filterStatus.includes("package") ||   // ✅ ADD THIS
  filterStatus.includes("paid") ||
  filterStatus.includes("unpaid");

const isStatusSelected =
  filterStatus.includes("paid") || filterStatus.includes("unpaid");

// const showPackages = filterStatus.includes("package");
  
  if (loading) {
  return (
    <div className="flex justify-center items-center py-16">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-gray-300 border-t-blue-500"></div>
    </div>
  );
}
  return (
    <>
      {/* ✅ Total Records */}
      {patients.length > 0 && (
        <p className="text-sm mb-2 text-gray-600">
          Total Records: {patients.length}
        </p>
      )}
      {/* Patients Table */}
     {showPatients && patients.length > 0 && (
        <div className="bg-white rounded-xl shadow overflow-x-auto mb-4">
          <table className="w-full text-sm text-center border-collapse">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 border-b text-[#204080]">VPJC ID</th>
                <th className="px-3 py-2 border-b text-[#204080]">Name</th>
                <th className="px-3 py-2 border-b text-[#204080]">Mobile</th>
                <th className="px-3 py-2 border-b text-[#204080]">Amount</th>
                <th className="px-3 py-2 border-b text-[#204080]">Type</th>
                <th className="px-3 py-2 border-b text-[#204080]">Status</th>
                {showBranchColumn && (
                  <th className="px-3 py-2 border-b text-[#204080]">Branch</th>
                )}
              </tr>
            </thead>
            <tbody>
              {patients.map((p) => (
                <tr key={`${p.vpjc_id}-${p.type}-${p.created_at?.seconds || p.created_at}`} className="border-t hover:bg-gray-50">
                  <td
                    className="px-3 py-2 text-blue-600 cursor-pointer hover:underline"
                    onClick={() => handleVPJCClick(p.vpjc_id)}
                  >
                    {p.vpjc_id}
                  </td>
                  <td className="px-3 py-2">{p.name}</td>
                  <td className="px-3 py-2">{p.mobile}</td>
                  <td className="px-3 py-2">₹{p.payment_amount}</td>
                  <td className="px-3 py-2">{p.type}</td>
                  <td
                    className={`px-3 py-2 font-semibold ${statusColor(p.payment_status)}`}
                  >
                    {formatStatus(p.payment_status || p.status)}
                  </td>
                  {showBranchColumn && (
                    <td className="px-3 py-2 whitespace-nowrap">
                      {p.branch_name?.replace(" Branch", "") || "-"}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Packages Table */}
     {/* {showPackages && packages.length > 0 && (
        <div className="bg-white rounded-xl shadow overflow-x-auto">
          <table className="w-full text-sm text-center border-collapse">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 border-b text-[#204080]">VPJC ID</th>
                <th className="px-3 py-2 border-b text-[#204080]">Name</th>
                <th className="px-3 py-2 border-b text-[#204080]">Mobile</th>
                <th className="px-3 py-2 border-b text-[#204080]">
                  Total Amount
                </th>
                <th className="px-3 py-2 border-b text-[#204080]">
                  Paid Amount
                </th>
                <th className="px-3 py-2 border-b text-[#204080]">
                  Due Amount
                </th>
                <th className="px-3 py-2 border-b text-[#204080]">Status</th>
                <th className="px-3 py-2 border-b text-[#204080]">
                  Duration (weeks)
                </th>
                <th className="px-3 py-2 border-b text-[#204080]">
                  Start Date
                </th>
                <th className="px-3 py-2 border-b text-[#204080]">
                  Expiry Date
                </th>
                {showBranchColumn && (
                  <th className="px-3 py-2 border-b text-[#204080]">Branch</th>
                )}
              </tr>
            </thead>
            <tbody>
              {packages.map((p) => (
                <tr key={p.vpjc_id} className="border-t hover:bg-gray-50">
                  <td
                    className="px-3 py-2 text-blue-600 cursor-pointer hover:underline"
                    onClick={() => handleVPJCClick(p.vpjc_id)}
                  >
                    {p.vpjc_id}
                  </td>
                  <td className="px-3 py-2">{p.name}</td>
                  <td className="px-3 py-2">{p.mobile}</td>
                  <td className="px-3 py-2">₹{p.total_amount}</td>
                  <td className="px-3 py-2">₹{p.paid_amount}</td>
                  <td className="px-3 py-2">₹{p.due_amount}</td>
                  <td
                    className={`px-3 py-2 font-semibold ${statusColor(p.status)}`}
                  >
                    {formatStatus(p.status)}
                  </td>
                  <td className="px-3 py-2">{p.duration_weeks}</td>
                  <td className="px-3 py-2">{formatDate(p.start_date)}</td>
                  <td className="px-3 py-2">{formatDate(p.expiry_date)}</td>
                  {showBranchColumn && (
                    <td className="px-3 py-2">
                      {p.branch_name?.replace(" Branch", "") || "-"}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )} */}

      {/* No Data */}
{hasSearched &&
  (
    (showPatients && patients.length === 0) 
    // && (showPackages && packages.length === 0)
  ) && (
    <p className="text-gray-500 mt-4">No records found</p>
)}
    </>
  );
}
